import { Box } from '@mui/material';
import styled from 'styled-components';

export const StyledContainer = styled(Box)`
    padding: 64px;
    max-width: 1200px;
    background: #ffffff;
    border: 1px solid rgba(224, 224, 224, 1);
    margin: 0 auto;
    border-radius: 40px;
    position: relative;
    width: 80%;
`;

export const Header = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
`;